import React, { useContext, useEffect, useState } from "react";
import {
  useMatch,
  useNavigate,
  useParams,
  useResolvedPath,
} from "react-router-dom";
import { IconCheveron, IconCircle } from "../../../icons/Icon";
import { StoreContext } from "../../../store/StoreContext";
import NavItemTemplate from "./NavItemTemplate";
import _ from "lodash";
import { useCallback } from "react";
import { SMU_SELECTED_MENU } from "../../../constants";

const SubNavItem = ({ item, addCurrentRoute }) => {
  const { category } = useParams();
  const resolved = useResolvedPath(item.path);
  const navigate = useNavigate();

  const { sidebarExpand, currentRoute, loadingSkirt } =
    useContext(StoreContext);

  const [expand, setExpand] = useState(false);

  const match = useMatch({ path: resolved.pathname, end: true });
  const active = Boolean(match) || category === String(item.id);
  const isChildren = item?.children?.length > 0;

  useEffect(() => {
    if (!sidebarExpand) {
      setExpand(false);
      return;
    }

    const route = _.find(currentRoute?.breadcrumbs, (r) => {
      return r.path === item.path;
    });
    setExpand(Boolean(route));
  }, [sidebarExpand]);

  const handleClick = useCallback(() => {
    if (loadingSkirt) return;

    // Always save to localStorage and navigate to promotions for all items
    localStorage.setItem(SMU_SELECTED_MENU, JSON.stringify(item));
    // Notify listeners (e.g., promotions view) that the selected menu changed
    window.dispatchEvent(new Event("smu-selected-menu-changed"));
    addCurrentRoute(item);
    navigate("promotions");

    // If it has children, also toggle expand
    if (isChildren) {
      setExpand((val) => !val);
    }
  }, [loadingSkirt, isChildren, item, addCurrentRoute, navigate]);

  const handleExpandClick = useCallback(() => {
    // Only toggle expand/collapse, no navigation
    setExpand((val) => !val);
  }, []);

  return (
    <NavItemTemplate
      disabled={loadingSkirt}
      title={item.title}
      handleClick={handleClick}
      handleExpandClick={isChildren ? handleExpandClick : null}
      active={active}
      icon={<IconCircle color="#748A9D" />}
      buttonExpand={
        isChildren && (
          <IconCheveron color="#33383F" />
        )
      }
      menuItemMainClass="py-2"
    >
      {isChildren && (
        <div className={`menu-item-child ${expand ? "expand" : ""}`}>
          {item.children.map((child) => (
            <SubNavItem
              key={child.id}
              item={child}
              addCurrentRoute={addCurrentRoute}
            />
          ))}
        </div>
      )}
    </NavItemTemplate>
  );
};

export default SubNavItem;
